import { render, staticRenderFns } from "./Events-info.vue?vue&type=template&id=51037747&"
import script from "./Events-info.vue?vue&type=script&lang=js&"
export * from "./Events-info.vue?vue&type=script&lang=js&"
import style0 from "./Events-info.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports